import { render, staticRenderFns } from "./order-detail-inquiry.vue?vue&type=template&id=69c97d7e&"
import script from "./order-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./order-detail-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports